// extracted by css-extract-rspack-plugin
export default {"ParametersWidgetContainer":"Wp9KX","allowSticky":"xNzCb","isSticky":"yeRrw","isNightMode":"KDK80","isEmbeddingSdk":"uwuQ5"};